// 法人番号検索(#3380 2章)。既存 postcode.js と同じくグローバル jQuery を副作用 import で使う。
import { corporateNumberValid } from './corporate_number';

$(function () {
  const $root = $('#corporate-number-search');
  if ($root.length === 0) return;

  const searchUrl = $root.data('search-url');
  const applicationUrl = $root.data('application-url');
  const companyPathTemplate = $root.data('company-path-template');
  const $number = $('#cns-corporate-number');
  const $numberHint = $('#cns-corporate-number-hint');
  const $name = $('#cns-name');
  const $address = $('#cns-address');
  const $includeClosed = $('#cns-include-closed');
  const $result = $('#cns-result');

  function escapeHtml(value) {
    return $('<div>').text(value == null ? '' : value).html();
  }

  function withParams(base, params) {
    return base + (base.indexOf('?') === -1 ? '?' : '&') + $.param(params);
  }

  function applyUrlFor(candidate) {
    return withParams(applicationUrl, {
      company_id: candidate.company_id,
      corporate_number: candidate.corporate_number,
      name: candidate.name,
      name_kana: candidate.name_kana,
      post_code: candidate.post_code,
      prefecture_name: candidate.prefecture_name,
      city_name: candidate.city_name,
      street_number: candidate.street_number
    });
  }

  function spacesCell(candidate) {
    if (!candidate.spaces || candidate.spaces.length === 0) {
      return candidate.registered ? '（権限内スペースなし）' : '（未登録）';
    }
    return candidate.spaces.map(function (name) { return escapeHtml(name); }).join('<br>');
  }

  // 新規取引先申請へのリンク(会社情報をセットして開く)
  function applyLink(candidate, label) {
    return '<a class="ui tiny primary button" href="' + escapeHtml(applyUrlFor(candidate)) + '">' + escapeHtml(label) + '</a>';
  }

  // 現スペースの会社詳細ページURL(登録済みのみリンクにする #3380)。
  function companyPath(id) {
    if (!companyPathTemplate || id == null) return null;
    return companyPathTemplate.replace('__ID__', encodeURIComponent(id));
  }

  // 登録済み表示(現スペース)。会社詳細へのリンクにする。編集させてよいのは登録済みだけ。
  function registeredCell(r) {
    var path = companyPath(r.company_id);
    if (!path) return '登録済み';
    return '<a href="' + escapeHtml(path) + '">登録済み</a>';
  }

  // 未登録セル。現スペースで申請中(未承認)なら「申請中」(詳細リンクは出さない)、
  // そうでなければ取引先申請の導線。
  function unregisteredCell(r) {
    if (r.applied) return '<span class="ui small label">申請中</span>';
    return applyLink(r, '取引先申請');
  }

  // 上位会社セル・協力会社セル(現スペースの上位/協力の登録状態で出し分け)。
  //   上位未登録 & 協力未登録 → 2列マージ(申請中 or 取引先申請)
  //   上位登録済 or 協力登録済 → 登録済み(詳細リンク) / 他方は申請中 or 取引先申請
  function relationCells(r) {
    if (!r.upper_registered && !r.coop_registered) {
      return '<td colspan="2" class="center aligned">' + unregisteredCell(r) + '</td>';
    }
    var upper = r.upper_registered ? registeredCell(r) : unregisteredCell(r);
    var coop = r.coop_registered ? registeredCell(r) : unregisteredCell(r);
    return '<td>' + upper + '</td><td>' + coop + '</td>';
  }

  // 新規取引先申請へ進む導線(該当なし/0件時にも使う)
  function applyFallbackButton() {
    const url = withParams(applicationUrl, {
      corporate_number: ($number.val() || '').replace(/[^\d]/g, ''),
      name: $name.val() || ''
    });
    return '<a class="ui primary button" href="' + escapeHtml(url) + '">新規取引先申請へ</a>';
  }

  function renderCandidates(records) {
    let rows = '';
    records.forEach(function (r) {
      const closedLabel = r.closed ? ' <span class="ui red label">閉鎖</span>' : '';
      rows += '<tr>'
        + '<td>' + escapeHtml(r.name) + closedLabel + '</td>'
        + '<td>' + escapeHtml(r.prefecture_name) + escapeHtml(r.city_name) + escapeHtml(r.street_number) + '</td>'
        + '<td>' + escapeHtml(r.corporate_number) + '</td>'
        + '<td>' + spacesCell(r) + '</td>'
        + relationCells(r)
        + '</tr>';
    });
    $result.html(
      '<table class="ui celled table"><thead><tr>'
      + '<th>企業名</th><th>所在地</th><th>法人番号</th><th>スペース</th><th>上位会社</th><th>協力会社</th>'
      + '</tr></thead><tbody>' + rows + '</tbody></table>'
    );
  }

  function renderResult(data) {
    if (data.valid === false) {
      $numberHint.text('チェックデジットが一致しません');
      $result.empty();
      return;
    }
    $numberHint.text('');

    if (data.too_many) {
      const count = data.count ? (data.count + '件が該当します。') : '該当が多すぎます。';
      $result.html('<div class="ui warning message">' + escapeHtml(count) + '検索条件を絞ってください（住所を加えると絞れます）。</div>');
      return;
    }
    if (!data.records || data.records.length === 0) {
      $result.html('<div class="ui message"><p>該当する法人が見つかりませんでした。設立して間もない法人は国のデータに載っていないことがあります。</p>'
        + applyFallbackButton() + '</div>');
      return;
    }
    renderCandidates(data.records);
  }

  function currentParams() {
    return {
      corporate_number: ($number.val() || '').replace(/[^\d]/g, ''),
      name: $name.val() || '',
      address: $address.val() || '',
      include_closed: $includeClosed.is(':checked')
    };
  }

  function runSearch() {
    const params = currentParams();
    const number = params.corporate_number;

    if (number.length > 0 && number.length < 13) {
      $numberHint.text('');
      $result.empty();
      return;
    }
    if (number.length === 13 && !corporateNumberValid(number)) {
      $numberHint.text('チェックデジットが一致しません');
      $result.empty();
      return;
    }
    $numberHint.text('');

    // 法人番号が無く、企業名も住所も空なら検索しない
    if (number.length === 0 && params.name.trim() === '' && params.address.trim() === '') {
      $result.empty();
      return;
    }

    $.ajax({ type: 'GET', url: searchUrl, data: params, dataType: 'json' })
      .done(renderResult)
      .fail(function () { $result.html('<div class="ui negative message">検索に失敗しました。</div>'); });
  }

  // #25: 入力即時の自動検索は、変換途中の発火や部分入力で件数がぶれ挙動が不安定なため廃止。
  // 検索は「検索」ボタン、または入力欄での Enter でのみ実行する。
  $('#cns-search-button').on('click', runSearch);
  $root.on('keydown', 'input', function (event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      runSearch();
    }
  });
});
